export const STAGE_KEYS = Object.freeze([
  'new_message',
  'new_lead',
  'consultation_pending_payment',
  'consultation_paid',
  'quote_sent',
  'surgery_scheduled',
  'surgery_completed',
  'therapies_completed',
  'controls_completed',
]);

export const STAGE_COLOR_KEYS = Object.freeze([
  'ink',
  'petrol',
  'plum',
  'brass',
  'mineral',
  'slate',
]);

export const DEFAULT_STAGE_COLORS = Object.freeze({
  new_message: 'ink',
  new_lead: 'ink',
  consultation_pending_payment: 'brass',
  consultation_paid: 'petrol',
  quote_sent: 'brass',
  surgery_scheduled: 'mineral',
  surgery_completed: 'mineral',
  therapies_completed: 'petrol',
  controls_completed: 'slate',
});

const COLOR_STYLES = Object.freeze({
  ink: {
    badge: 'bg-n-blue-3 text-n-blue-11',
    bar: 'bg-n-blue-9 text-white',
    cardBorder: 'border-l-n-blue-8',
    columnBorder: 'border-t-n-blue-8',
    dot: 'bg-n-blue-9',
  },
  petrol: {
    badge: 'bg-n-teal-3 text-n-teal-11',
    bar: 'bg-n-teal-9 text-white',
    cardBorder: 'border-l-n-teal-8',
    columnBorder: 'border-t-n-teal-8',
    dot: 'bg-n-teal-9',
  },
  plum: {
    badge: 'bg-n-violet-3 text-n-violet-11',
    bar: 'bg-n-violet-9 text-white',
    cardBorder: 'border-l-n-violet-8',
    columnBorder: 'border-t-n-violet-8',
    dot: 'bg-n-violet-9',
  },
  brass: {
    badge: 'bg-n-amber-3 text-n-amber-11',
    bar: 'bg-n-amber-9 text-n-amber-12',
    cardBorder: 'border-l-n-amber-8',
    columnBorder: 'border-t-n-amber-8',
    dot: 'bg-n-amber-9',
  },
  mineral: {
    badge: 'bg-n-teal-4 text-n-teal-12',
    bar: 'bg-n-teal-10 text-white',
    cardBorder: 'border-l-n-teal-10',
    columnBorder: 'border-t-n-teal-10',
    dot: 'bg-n-teal-10',
  },
  slate: {
    badge: 'bg-n-slate-3 text-n-slate-11',
    bar: 'bg-n-slate-9 text-white',
    cardBorder: 'border-l-n-slate-8',
    columnBorder: 'border-t-n-slate-8',
    dot: 'bg-n-slate-9',
  },
});

export const stageColorClasses = color =>
  COLOR_STYLES[color] || COLOR_STYLES.slate;

export const stageColorsFromRecords = records => {
  if (!Array.isArray(records) || records.length !== STAGE_KEYS.length) {
    throw new Error('Invalid stage color response');
  }

  const colors = Object.fromEntries(
    records.map(record => [record.key, record.color])
  );
  const hasExactStages =
    Object.keys(colors).length === STAGE_KEYS.length &&
    STAGE_KEYS.every(stage => Object.hasOwn(colors, stage));
  const hasValidColors = Object.values(colors).every(color =>
    STAGE_COLOR_KEYS.includes(color)
  );

  if (!hasExactStages || !hasValidColors) {
    throw new Error('Invalid stage color response');
  }

  return colors;
};

export const buildStageDefinitions = (t, colors = DEFAULT_STAGE_COLORS) =>
  STAGE_KEYS.map(key => ({
    key,
    label: t(`CLINICAL_CRM.STAGES.${key}`),
    color: colors[key] || DEFAULT_STAGE_COLORS[key],
  }));
